<template>
  <div id="HealthcareHoursMain">


         <keep-alive> <router-view></router-view></keep-alive>


  </div>
</template>

<script>
  export default {

    data() {
      return {
        show: false,
      }
    },
    methods: {
      back() {
        this.$router.push('/dashboard')
      }
    },
    computed: {
      user() {
      return this.$store.getters.user;
      },
      totalShadowingHours() {
          return this.paShadow.logged_hours.reduce((sum, loggedHours)=> {
             return sum + parseFloat(loggedHours.shadowing_hours)
        }, 0)
      },
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;

  }
  .card {
    border-radius: 5px;

  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/HealthcareHoursMain.vue